import { createContext } from 'react';
import { DashboardCommerciauxContextProps } from './DashboardCommerciaux.types';

export const DashboardCommerciauxContext = createContext<DashboardCommerciauxContextProps>(
  {} as DashboardCommerciauxContextProps
);
